module.exports = __webpack_public_path__ + "static/media/prevent2.f0fb7bef.png";